export function LabTickIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg aria-hidden xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" viewBox="0 0 14 14" className="size-3.5" {...props}>
      <g clipPath="url(#a)">
        <path fill="currentColor" fillRule="evenodd" d="M5.333 10.225 1.652 7.464l.696-.928 2.985 2.239 6.319-4.739.696.928-7.015 5.261Z" clipRule="evenodd" />
      </g>
    </svg>
  );
}
